import { shape, string, number, func, arrayOf, oneOfType, bool, any } from 'prop-types';

export const inputPropTypes = shape({
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: string.isRequired
});

export const metaPropTypes = shape({
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool.isRequired,
  submitting: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired
});

export const fieldType = shape({
  id: number,
  type: string.isRequired,
  order: number,
  suborder: number,
  code: string,
  title: string,
  description: string,
  required: bool,
  required_message: string,
  key: string.isRequired,
  placeholder: string,
  tooltip: string,
  format: string,
  format_error_message: string,
  form_id: number,
  child_keys: any,
  visibility_parent_field_key_id: number,
  visibility_parent_field_option_value_id: number,
  visibility_parent_field_option_values: arrayOf(any),
  visibility_toggleable_field_id: number,
  visibility_toggleable_field_value: string,
  visibility_checkbox_field_id: number,
  visibility_checkbox_field_value: string,
  read_only: bool,
  default_value: oneOfType[(string, arrayOf(any))],
  auxiliary: bool,
  hidden: bool,
  logic_evaluation: string,
  logic_evaluation_error_message: string,
  image_url: string,
  configuration: shape(any),
  field_options: arrayOf(
    shape({
      name: string.isRequired,
      id: oneOfType([string, number]).isRequired
    })
  )
});

export const UtFormFieldPropTypes = {
  field: fieldType.isRequired,
  formAccount: any, // eslint-disable-line react/forbid-prop-types
  input: inputPropTypes,
  meta: metaPropTypes,
  selectedOptionIds: any, // eslint-disable-line react/forbid-prop-types
  useModal: bool,
  isPublic: bool
};

export const formResponseTypes = shape({
  // TODO: Check this type. Maybe will change
  title: string.isRequired,
  id: number.isRequired,
  status: string.isRequired,
  date: string.isRequired,
  notification: bool
});

export const userFormType = {
  id: number,
  order: number,
  form_category_id: number,
  name: string,
  code: string,
  brief_description: string,
  group_external_key: string,
  detailed_description: string,
  cancellable: bool,
  reiterable: bool,
  auto_closure: bool,
  type: string,
  custom: bool,
  fields: arrayOf(fieldType)
};
